
  declare var window: any;
  export default {
    props: {
      instructions: String
    },
    data() {
      window.wf ??= {};
      window.locations ??= {};
      let d = window.wf.LocationDirectory;
      d.locations ??= {};
      d.selectedCountry ??= '';
      d.selectedState ??= '';
      d.selectedAirport ??= '';
      return d;
    },
    methods: {
      resetFilters() {
        this.selectedCountry = '';
        this.selectedState= '';
        this.selectedAirport = '';
      },
      updateFilters() {
        var tempFilteredLocations = this.filteredLocations;
      },
      updateSelectedCountry() {
        if (this.selectedCountry != '') {
          this.selectedAirport = '';
        }
        this.updateFilters();
      },
      updateSelectedAirport() {
        if (this.selectedAirport != '') {
          this.selectedCountry = '';
        }
        this.updateFilters();
      },
      updateMapLocations(tempFilteredLocations) {
        var tempWindowLocations = [];
        var i;
        if (tempFilteredLocations.length > 0) {
          for (i = 0; i < tempFilteredLocations.length; i++) {
            var tempLocation = tempFilteredLocations[i];
            tempWindowLocations.push(
              {
                name: tempLocation.name,
                address: tempLocation.city + ', ' + this.getNameOfState(tempLocation.state) + ', ' + this.getNameOfCountry(tempLocation.country),
                lat: tempLocation.lat,
                long: tempLocation.long,
              }
            )
          }
        }
        window.locations = tempWindowLocations;
        initMap();
      },
      getNameOfState(statecode) {
        let filteredStates = this.states.filter((state) => {
          return (state.code == statecode)
        })
        if (filteredStates != null && filteredStates.length > 0) {
          return filteredStates[0].name;
        }
        return statecode;
      },
      getNameOfCountry(countrycode) {
        let filteredCountry = this.countries.filter((country) => {
          return (country.code == countrycode)
        })
        if (filteredCountry != null && filteredCountry.length > 0) {
          return filteredCountry[0].name;
        }
        return countrycode;
      }
    },
    computed: {
      filteredLocations() {
        var tempFilteredLocations = this.locations;

        if (this.selectedCountry != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.country == this.selectedCountry);
        }
        if (this.selectedCountry != 'USA') {
          this.selectedState = '';
        }
        if (this.selectedState != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.state == this.selectedState);
        }
        if (this.selectedAirport != '') {
          tempFilteredLocations = tempFilteredLocations.filter(el => el.airport == this.selectedAirport);
        }
        // update locations for map whenever the filtered locations are recalculated
        this.updateMapLocations(tempFilteredLocations);

        return tempFilteredLocations;
      }
    }
  }

